import React, { Children, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { v4 as uuidv4 } from 'uuid'; // Standardized import naming
import FormRadio from './FormRadio';
import './FormIconChooser.scss';

const IconChooser = ({ 
  className = '', 
  children = [], 
  itemClass = '' 
}) => {
  
  // 1. Memoize to prevent unnecessary DOM thrashing
  const renderIcons = useMemo(() => {
    return Children.toArray(children).map((Child) => {
      /* * 2. Key Strategy: Try to use the child's value or name as a stable key.
       * Falling back to a UUID is okay, but stable keys are better for performance.
       */
      const stableKey = Child.props?.value || Child.props?.name || uuidv4();

      return (
        <li
          key={stableKey}
          className={classNames('icon-chooser-list__item', itemClass)}
        >
          {Child}
        </li>
      );
    });
  }, [children, itemClass]);

  return (
    <ul className={classNames('icon-chooser', className)}>
      {renderIcons}
    </ul>
  );
};

IconChooser.propTypes = {
  // 3. Custom validator to enforce child types
  children: (props, propName, componentName) => {
    const prop = props[propName];
    let error = null;

    Children.forEach(prop, (child) => {
      // Check if child is a valid React element and matches FormRadio
      if (child && child.type !== FormRadio) {
        error = new Error(
          `"${componentName}" expected children of type "FormRadio", but found "${child.type?.name || child.type}".`
        );
      }
    });
    return error;
  },
  itemClass: PropTypes.string,
  className: PropTypes.string
};

export default IconChooser;
